export const urlParser = (url) => {
  switch(url) {
    case 'technologia-myjaca':
      return 'WASHING_TECHNOLOGY';
    case 'wydawanie-reszty':
      return 'ISSUING_REST';
    case 'platnosc-karta':
      return 'CARD_PAYMENT';
    case 'wydluzony-czas-mycia':
      return 'LONG_WASHING_TIME';
    default:
      return '404';
  }
};


// WEBPACK FOOTER //
// ./src/utils/urlParser.js